var render, staticRenderFns
import script from "./SalespersonChart.vue?vue&type=script&lang=js"
export * from "./SalespersonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1590be",
  null
  
)

export default component.exports